import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate'
import FontFaceObserver from 'fontfaceobserver'

import { addEventListener, removeEventListener } from '../../utils'

import './ReadMoreComponent.scss'

class ReadMoreComponent extends PureComponent {
  constructor(props) {
    super(props)

    this.state = { expanded: false, isFontLoaded: false }

    this.isAnimating = false
    this.collapsedHeight = 0
    this.styleReadMoreComponent = {
      overflow: 'hidden',
      transition: `height ${props.transitionDuration} ${props.transitionTimingFunction}`,
    }

    this.handleTruncate = this.handleTruncate.bind(this)
    this.toggleLines = this.toggleLines.bind(this)
    this.onCollapsed = this.onCollapsed.bind(this)
  }

  componentDidMount() {
    const styles = window.getComputedStyle(this.fontLoader)
    const { fontFamily, weight, style } = styles

    this.fonts = fontFamily.replace(/"/g, '').split(',')
    this.loadFont(this.fonts[0], weight, style)
  }

  componentWillUnmount() {
    this.removeTransitionListener()
  }

  handleTruncate(truncated) {
    if (truncated && this.collapsedHeight === 0) {
      const height = this.setReadMoreComponentHeight()
      this.collapsedHeight = height
    }
  }

  onCollapsed() {
    this.removeTransitionListener()
    this.isAnimating = false
    this.setState({ expanded: false })
  }

  setReadMoreComponentHeight() {
    const { height } = window.getComputedStyle(this.readMoreBody)
    this.readMoreComponent.style.height = height
    return height
  }

  removeTransitionListener() {
    removeEventListener(this.readMoreComponent, this.onCollapsed)
  }

  addTransitionListener() {
    addEventListener(this.readMoreComponent, this.onCollapsed)
  }

  loadFont(font, weight, style) {
    new FontFaceObserver(font, { weight, style }).load().then(
      () => {
        this.setState({ isFontLoaded: true })
      },
      () => {
        const fontIndex = this.fonts.indexOf(font)
        const nextFont = this.fonts[fontIndex + 1]
        if (nextFont === undefined) {
          // no more fonts lets render the text with best effort
          this.setState({ isFontLoaded: true })
        } else {
          this.loadFont(nextFont, weight, style)
        }
      }
    )
  }

  toggleLines(actionType) {
    if (actionType === 'more') {
      this.setState({ expanded: true }, this.setReadMoreComponentHeight)
    } else if (!this.isAnimating) {
      this.isAnimating = true
      this.addTransitionListener()
      this.readMoreComponent.style.height = this.collapsedHeight
    }
  }

  renderEllipsis() {
    const { more } = this.props
    return (
      <span>
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        ...
        {this.renderTriggerButton(more, 'more')}
      </span>
    )
  }

  renderTriggerButton(text, actionType) {
    return (
      <>
        &nbsp;
        <span
          className="trigger-button"
          onClick={() => this.toggleLines(actionType)}
        >
          {text}
        </span>
      </>
    )
  }

  render() {
    const { isFontLoaded } = this.state
    if (!isFontLoaded) {
      return (
        <span
          style={{ fontSize: 0 }}
          ref={(fontLoader) => {
            this.fontLoader = fontLoader
          }}
        />
      )
    }

    const { children, less, lines } = this.props
    const { expanded } = this.state

    return (
      <div
        className="read-more-component"
        style={this.styleReadMoreComponent}
        ref={(readMoreComponent) => {
          this.readMoreComponent = readMoreComponent
        }}
      >
        <div
          className="read-more-body"
          ref={(readMoreBody) => {
            this.readMoreBody = readMoreBody
          }}
        >
          <Truncate
            lines={!expanded && lines}
            onTruncate={this.handleTruncate}
            ellipsis={this.renderEllipsis()}
          >
            {children}
          </Truncate>
          {expanded && this.renderTriggerButton(less, 'less')}
        </div>
      </div>
    )
  }
}

ReadMoreComponent.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  more: PropTypes.string,
  less: PropTypes.string,
  transitionDuration: PropTypes.string,
  transitionTimingFunction: PropTypes.string,
}

ReadMoreComponent.defaultProps = {
  lines: 3,
  more: 'Read more',
  less: 'Show less',
  transitionDuration: '.3s',
  transitionTimingFunction: 'ease-in-out',
}

export default ReadMoreComponent
